/**
 * CompaniesEditor Component
 *
 * Entity-specific editor for Companies lookup table
 */

import {
  useCompanies,
  useCreateCompany,
  useUpdateCompany,
  useDeleteCompany,
} from '@medsuite/api-client';

import EntityEditor from '../components/EntityEditor';

interface CompaniesEditorProps {
  onDataLoaded?: (count: number) => void;
}

export default function CompaniesEditor({ onDataLoaded }: CompaniesEditorProps) {
  const { data: companies = [], isLoading, error } = useCompanies();
  const addMutation = useCreateCompany();
  const updateMutation = useUpdateCompany();
  const deleteMutation = useDeleteCompany();

  const columns = [
    { key: 'company_id', label: 'ID', readonly: true },
    { key: 'company_name', label: 'Company Name', type: 'text' as const },
  ];

  return (
    <EntityEditor
      title="Companies"
      columns={columns}
      data={companies as unknown as Record<string, unknown>[]}
      isLoading={isLoading}
      error={error}
      primaryKey="company_id"
      onDataLoaded={onDataLoaded}
      onAdd={async (item) => {
        await addMutation.mutateAsync(item as { company_name: string });
      }}
      onUpdate={async (id, item) => {
        await updateMutation.mutateAsync({ id: Number(id), data: item as { company_name: string } });
      }}
      onDelete={(id) => deleteMutation.mutateAsync(Number(id))}
      isAdding={addMutation.isPending}
      isUpdating={updateMutation.isPending}
      isDeleting={deleteMutation.isPending}
    />
  );
}
